import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';


@Component({
  selector: 'tt-coops',
  templateUrl: './coops.component.html',
  styleUrls: ['./coops.component.css']
})
export class CoopsComponent implements OnInit {
    public itemsListCoops: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadCoops(): Promise<void> {
        this.itemsListCoops = await this.datatask.Post(2727);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'coop':
                this.stateService?.go('coop', { coop_id: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadCoops();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('coops', {
//        templateUrl: 'views/components/views/coops/coops.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'coopsService', function (stateService, coopsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCoops: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadCoops() {
//                vm.model.itemsListCoops = await coopsService.listCoops();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'coop':
//                        go({ coop_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadCoops();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
